<rwidget-route-list [types]="availableTypes"></rwidget-route-list>
